<div class="simple-alert-container container default-padding clickable {{ color }}" matRipple (click)="handleClick()">
  <div class="content-container" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="15px">
    <fa-icon [icon]="icon" size="2x"></fa-icon>
    <div fxLayout="column">
      <strong>{{ title || ('ALERT.NO_TITLE' | translate) }}</strong>
      <small>{{ text || ('ALERT.NO_TEXT' | translate) }}</small>
    </div>
  </div>
</div>
